import { render } from "./Dialog-pyramid.vue?vue&type=template&id=6d4a08cd&scoped=true"
import script from "./Dialog-pyramid.vue?vue&type=script&lang=js"
export * from "./Dialog-pyramid.vue?vue&type=script&lang=js"

import "./Dialog-pyramid.vue?vue&type=style&index=0&id=6d4a08cd&lang=css"
import "./Dialog-pyramid.vue?vue&type=style&index=1&id=6d4a08cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4a08cd"]])

export default __exports__